module.exports = __webpack_public_path__ + "img/treatment.0a087caf.jpg";